import {
  createUserActionUserActionsCreatePost,
  type CreateUserActionResponse,
} from '../client';

/**
 * Хук для централізованого створення user actions.
 * Оновлення квестів тепер відбувається через Socket.IO (quests:invalidate),
 * тому оптимістичне оновлення прибрано.
 */
export function useCreateUserAction() {
  const createUserAction = async (
    action:
      | "visit_city_hall"
      | "visit_shop"
      | "visit_hell_of_flame"
      | "visit_player_house"
      | "watch_ad_interstitial_26097"
      | "watch_ad_task_26003"
      | "follow_x"
      | "follow_x_y0news_ai"
      | "follow_x_y0news_crypto"
      | "buy_furniture",
    mapObjectId?: number
  ): Promise<CreateUserActionResponse> => {
    const { data } = await createUserActionUserActionsCreatePost({
      body: {
        action,
        ...(mapObjectId !== undefined ? { map_object_id: mapObjectId } : {}),
      },
      throwOnError: true,
    });
    return data;
  };

  return { createUserAction };
}
